import { render } from "./manageScreens.vue?vue&type=template&id=4be92f0e&scoped=true&ts=true"
import script from "./manageScreens.vue?vue&type=script&lang=ts"
export * from "./manageScreens.vue?vue&type=script&lang=ts"

import "./manageScreens.vue?vue&type=style&index=0&id=4be92f0e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be92f0e"]])

export default __exports__